module.exports = "https://coursera_assets.s3.amazonaws.com/images/da378222c65afacfbfb884f2cf0179d9.png";